import React from "react";

import { TitleSmall } from "Cobalt/Header";
import { Card, CardSection } from "Common/Card/";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import type { StyleProps } from "Utils/styleProps";

import makeBem from "Utils/makeBem";

const bem = makeBem("ToggleCard");
type Props = StyleProps & {
  label: React.ReactNode;
  isUp: boolean;
  onClick: () => void;
};
export default class ToggleCard extends React.Component<Props> {
  render() {
    const { label, onClick, isUp, ...otherProps } = this.props;
    return (
      <Card onClick={onClick} className={bem()} {...otherProps} p={0}>
        <CardSection className={bem("Container")} px={4} py={4}>
          <Div className={bem("HeaderContainer")}>
            <TitleSmall mt={0} mb={0}>
              {label}
            </TitleSmall>
          </Div>
          <Div className={bem("ToggleIndicatorContainer")}>
            <Icon className={bem("ToggleIndicator")} icon={isUp ? "angle-up" : "angle-down"} />
          </Div>
        </CardSection>
      </Card>
    );
  }
}
